'use strict';

export default (API) => ({
    resources: {
        get: (establishmentId, resourceId) => {
            const url = 'v3/establishments/' + establishmentId + '/resources/' + resourceId;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getGlobal: (resourceId) => {
            const url = 'v3/resources/' + resourceId;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAvailable: () => {
            const url = 'v3/resources/available?prestOnly=true';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllByEstablishment(establishmentId, light = false, byPrestOnly = true) {
            let url = `v3/establishments/${establishmentId}/resources?light=${light}&byPrestOnly=${byPrestOnly}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllByEstablishmentForFilters(establishmentId) {
            let url = `v3/establishments/${establishmentId}/resources/for-filter`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllByEstablishmentForConfig(establishmentId) {
            let url = `v3/establishments/${establishmentId}/resources/for-config`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllArchivedResourcesByEstablishmentForConfig(establishmentId) {
            let url = `v3/establishments/${establishmentId}/resources/for-config?listArchived=true`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getResourceSettingsByIds: (establishmentId, resourceId) => {
            const url = 'v3/resources/' + resourceId + '/settings/establishments/' + establishmentId;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getCurrent: () => {
            const url = 'v3/resources/current';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getResourcesByName(name) {
            const url = 'v3/resources/search?name=' + name;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllResources() {
            const url = 'v3/resources';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllByEstablishmentPublic(establishmentId) {
            const url = 'v3/establishments/' + establishmentId + '/resources?light=true';
            const params = {
                light: true,
            };
            const request = API.http.get(url, params);
            return API.handleError(request);
        },
        getServiceAndPlaceIndexes(establishmentId, resourceId) {
            const url = 'v3/establishments/' + establishmentId + '/places/resources/' + resourceId + '/services/indexes';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllServiceAndPlaceIndexesByResource(establishmentId) {
            const url = 'v3/establishments/' + establishmentId + '/resources/services/places/indexes';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getPrestForOneResourceForOnePlace(establishmentId, placeId, resourceId) {
            const url = `v3/establishments/${establishmentId}/places/${placeId}/resources/${resourceId}/services`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getOnePrest(establishmentId, placeId, resourceId, serviceId, light = true) {
            const url = `v3/establishments/${establishmentId}/places/${placeId}/resources/${resourceId}/services/${serviceId}?resourceFields=${light}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getResourceConfigurationMessages(resourceId) {
            const url = `v3/resources/${resourceId}/configuration/messages`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getResourceConfigurationMessagesByEstablishment(establishmentId, resourceId) {
            const url = `v3/establishments/${establishmentId}/resources/${resourceId}/configuration/messages`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        setPrestBatch(establishmentId, arrPrest) {
            const url = `v3/establishments/${establishmentId}/places/resources/services`;
            const request = API.http.put(url, arrPrest);
            return API.handleError(request);
        },

        getCategories: (clicsante) => {
            let url = 'v3/resources/categories';
            if (clicsante) url += '?clicsante=true';
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getRoles: (clicsante) => {
            let url = 'v3/roles';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getTypes: () => {
            const url = 'v3/resources/types';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        create: (establishmentId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/resources/';
            const request = API.http.post(url, params);
            return API.handleError(request);
        },
        invite: (establishmentId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/resources/invite';
            const request = API.http.post(url, params);
            return API.handleError(request);
        },
        update: (establishmentId, resourceId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/resources/' + resourceId;
            const request = API.http.put(url, params);
            return API.handleError(request);
        },
        delete: (establishmentId, resourceId, validate) => {
            const url = `v3/establishments/${establishmentId}/resources/${resourceId}?validate=${validate}`;
            const request = API.http.delete(url);
            return API.handleError(request);
        },
        updateStatus: (establishmentId, resourceId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/resources/' + resourceId + '/status';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        restoreResource: (establishmentId, resourceId) => {
            const url = 'v3/establishments/' + establishmentId + '/resources/' + resourceId + '/restore';
            const request = API.http.put(url, null, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateOrder: (establishmentId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/resources/order';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateResourceSettings: (establishmentId, resourceId, payload) => {
            const url = 'v3/establishments/' + establishmentId + '/resources/' + resourceId + '/settings';
            const request = API.http.put(url, payload);
            return API.handleError(request);
        },
        getAvailableRoles: function(establishmentId, resourceId) {
            const url = 'v3/establishments/' + establishmentId + '/resources/' + resourceId + '/roles';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        createResourceRoles: (establishmentId, resourceId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/resources/' + resourceId + '/roles';
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateResourceRoles: (establishmentId, resourceId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/resources/' + resourceId + '/roles';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        deleteResourceRoles: (establishmentId, resourceId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/resources/' + resourceId + '/roles';
            const request = API.http.delete(url, { headers: { 'Content-Type': 'application/json' }, data: params });
            return API.handleError(request);
        },
        updateConfigurationMessages: (resourceId, params) => {
            const url = 'v3/resources/' + resourceId + '/configuration/messages';
            const request = API.http.put(url, params);
            return API.handleError(request);
        },
        updateResourceReactsAccount: (establishmentId, resourceId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/resources/' + resourceId + '/reacts_account';
            const request = API.http.put(url, params);
            return API.handleError(request);
        },
    },
});
